export const tiersDeLegacy = {
  "tierSetupGeneral.tierPurchases.label": "Für Stufe erforderliche Anzahl der Käufe ",
  "benefitDefaultData.pointsBenefitText.multiCurrency":
    "Erhalten Sie {{pointsToken}} mit jeder/m ausgegebene(n) {{currencyToken}}"
};
